import React, { useEffect, useRef } from 'react';
import Slider from "react-slick";
import { Svg } from './Svg';

const Carousel = ({values}) => {
    const CustomArrow = ({onClick, direction = 'left', extraClass = ''}) => {
        return (
            <button className={`slick-arrow ${extraClass}`} type="button" onClick={onClick}>
                <Svg icon="chevron" extraClass={`chevron-${direction}`}/>
            </button>
        )
    }

    const resizeTimeoutRef = useRef(0);
    const sliderRef = useRef(null);
    const sliderContainerRef = useRef(null);
    let slidesToShowByDefault = values.length < 3 ? 3 : 4;

    const settings = {
        dots: false,
        infinite: values.length >= 4,
        speed: 500,
        prevArrow: <CustomArrow extraClass="slick-prev"/>,
        nextArrow: <CustomArrow extraClass="slick-next" direction="right"/>,
        slidesToShow: slidesToShowByDefault,
        slidesToScroll: 1,
        rtl: false,
        rows: 1,
        mobileFirst: false,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "50px 0  0",
                    infinite: values.length >= 2,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    centerPadding: "60px 0  0",
                    infinite: values.length >= 3,
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    infinite: values.length >= 3,
                }
            },
        ]
    };

    const recalculateHeightVariable = (ref) => {
        setTimeout(() => {
            let slickTrack = ref.current.querySelector('.slick-track');
            if (slickTrack) {
                let slickTrackHeight = slickTrack.offsetHeight;
                ref.current.firstChild.style.setProperty('--slick-card-height', slickTrackHeight + 'px');
            }
        }, 200);
    }

    const handleResize = () => {
        sliderContainerRef.current.firstChild.style.removeProperty('--slick-card-height');

        if (resizeTimeoutRef.current) {
            clearTimeout(resizeTimeoutRef.current);
        }

        resizeTimeoutRef.current = setTimeout(() => {
            recalculateHeightVariable(sliderContainerRef);
        }, 500);
    };

    useEffect(() => {
        if (sliderRef.current && sliderContainerRef.current) {
            recalculateHeightVariable(sliderContainerRef);
            window.addEventListener('resize', handleResize);
        }

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div ref={sliderContainerRef}>
            <Slider {...settings} ref={sliderRef}>
                {values.map((value, index) => (
                    <div
                        className='slick-slide__inner'
                        key={`figure${index}`}
                        dangerouslySetInnerHTML={{
                            __html: value.html,
                        }}
                    ></div>
                ))}
            </Slider>
        </div>
    );
}

export default Carousel;